export const exchangeRateConstants = {
    EXCHANGE_RATE_CREATE_REQUEST: 'EXCHANGE_RATE_CREATE_REQUEST',
    EXCHANGE_RATE_CREATE_SUCCESS: 'EXCHANGE_RATE_CREATE_SUCCESS',
    EXCHANGE_RATE_CREATE_FAILURE: 'EXCHANGE_RATE_CREATE_FAILURE',

    EXCHANGE_RATE_REMOVE_REQUEST: 'EXCHANGE_RATE_REMOVE_REQUEST',
    EXCHANGE_RATE_REMOVE_SUCCESS: 'EXCHANGE_RATE_REMOVE_SUCCESS',
    EXCHANGE_RATE_REMOVE_FAILURE: 'EXCHANGE_RATE_REMOVE_FAILURE'
};
